import React, {useEffect, useState} from "react";

const SVGComponent = ({ svgUrl, className }: { svgUrl: string, className?: string }) => {
    const [svgContent, setSvgContent] = useState<string>("");

    useEffect(() => {
        const fetchSvg = async () => {
            try {
                const response = await fetch(svgUrl);
                const svgText = await response.text();
                setSvgContent(svgText);
            } catch (error) {
                console.error("Error fetching SVG:", error);
            }
        };

        if (svgUrl) {
            fetchSvg();
        }
    }, [svgUrl]);

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: svgContent }}
            style={{ width: '100%', height: '100%' }}
        />
    );
};

export default SVGComponent;
